/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MFASend = {
    mfa_method: MFASend.mfa_method;
    readonly mfa_app_uri?: string;
}

export namespace MFASend {

    export enum mfa_method {
        EMAIL = 'email',
        SMS = 'sms',
        APP = 'app',
    }


}
